import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from '@/shared/api';

export const makeStore = () => configureStore({
  reducer: { [baseApi.reducerPath]: baseApi.reducer },
  middleware: (gd) => gd().concat(baseApi.middleware),
});
